import {AbstractControl} from '@angular/forms';

export function conditionalValidator(predicate: any, validator: any) {
  return (formControl: AbstractControl) => {
    if (!formControl.parent) {
      return null;
    }

    if (predicate()) {
      return validator(formControl);
    }

    return null;
  };
}
